import React, { createContext, useCallback, useContext, useState } from "react";
import PhotoViewer from "../modals/PhotoViewer";
import { fetchPublicGalleryAlbum } from "../../utils/publicGalleryApi";

const GalleryViewerContext = createContext({
  openAlbum() {},
  openAlbumSlug() {},
});

export function useGalleryViewer() {
  return useContext(GalleryViewerContext);
}

export function GalleryViewerProvider({ children }) {
  const [album, setAlbum] = useState(null);
  const [index, setIndex] = useState(0);

  const openAlbum = useCallback((next, startIndex = 0) => {
    if (!next || !Array.isArray(next.photos) || next.photos.length === 0) return;
    setIndex(Math.max(0, startIndex));
    setAlbum(next);
  }, []);

  const openAlbumSlug = useCallback(
    async (slug) => {
      const loaded = await fetchPublicGalleryAlbum(slug);
      if (loaded) openAlbum(loaded, 0);
    },
    [openAlbum],
  );

  const close = useCallback(() => setAlbum(null), []);

  return (
    <GalleryViewerContext.Provider value={{ openAlbum, openAlbumSlug }}>
      {children}
      {album ? (
        <PhotoViewer album={album} initialIndex={index} onClose={close} />
      ) : null}
    </GalleryViewerContext.Provider>
  );
}
